import React, { useState, useMemo, useCallback } from 'react';
import { styled, LazyImage, Overlay, Gallery } from '@teko/ui';
import { SmallImage } from './SmallImage/SmallImage.es.js';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Images = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
`;
const Wrapper = styled.div`
  background-color: #fff;
`;
const ActiveImageWrapper = styled.div`
  margin-bottom: 0.5rem;
  position: relative;
`;
const FrameWrapper = styled.div(({ frame }) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  cursor: pointer;
  `);
const ProductImages = ({
  images,
  frame,
  sku,
  galleryBgColor
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndexSlide, setActiveIndexSlide] = useState(0);
  const activeImage = useMemo(() => images[activeIndex], [activeIndex, images]);
  const maxFourImages = useMemo(() => images.slice(0, 6), [images]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const toggleGallery = useCallback(() => {
    setGalleryVisible(!galleryVisible);
  }, [galleryVisible]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndex
    })
  })), /* @__PURE__ */ React.createElement(ActiveImageWrapper, {
    onClick: () => activeImage && toggleGallery()
  }, frame && /* @__PURE__ */ React.createElement(FrameWrapper, {
    frame
  }), /* @__PURE__ */ React.createElement(LazyImage, __spreadProps(__spreadValues({}, activeImage), {
    onClick: () => activeImage && toggleGallery(),
    className: "productDetailPreview",
    borderRadius: 8,
    imageWidth: 500,
    contain: true
  }))), /* @__PURE__ */ React.createElement(Images, null, maxFourImages.map((image, index) => /* @__PURE__ */ React.createElement(SmallImage, {
    key: index,
    active: index === activeIndex,
    image,
    onMouseEnter: () => {
      !(index === 5 && images.length > 6) && setActiveIndex(index);
      setActiveIndexSlide(index);
    },
    onClick: () => {
      toggleGallery();
    },
    extra: index === 5 && images.length > 6 ? `+${images.length - 6}` : void 0
  }))), /* @__PURE__ */ React.createElement(Overlay, {
    show: galleryVisible,
    onEscPressed: toggleGallery
  }, /* @__PURE__ */ React.createElement(Gallery, {
    onClose: toggleGallery,
    images: images.map((image) => ({
      imageUrl: image.src,
      caption: "",
      subCaption: "",
      thumbnailUrl: image.src
    })),
    activeImageIndex: activeIndexSlide,
    bgColor: galleryBgColor
  })));
};

export { ProductImages };
